module.exports = __webpack_public_path__ + "static/img/contact_img_small routine.5e76beb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/guanyu/contact_img_small routine.png
// module id = 5nqY
// module chunks = 1